import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

const DescriptionInterstep = () => {
    const { t } = useTranslation();

    return (
        <div className="description-interstep">
            <h3 className="title title--small">{t('exercise.transition.menu.title')}</h3>
            <img alt="waiting" src="/img/waiting.svg" />
        </div>
    );
};

export default DescriptionInterstep;
